module.exports = __webpack_public_path__ + "static/media/select-file.b894fc4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/select-file.svg
// module id = 176
// module chunks = 0